import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

import React from 'react';
import PropTypes from 'prop-types';
import BootstrapTable from 'react-bootstrap-table-next';

const UserTable = ({ users, role, history }) => {
    const { pagination, byid, list } = users
    const { currentPage, itemPerPage } = pagination

    let indexEnd = currentPage * itemPerPage;
    let indexStart = indexEnd - itemPerPage
    if (indexEnd > list.length) {
        indexEnd = list.length
    }
    let itemsList = list.slice(indexStart, indexEnd)

    let columns = [
        {
            dataField: 'id',
            text: '#',
            headerClasses: "table-col-head",
            hidden: true
        }, {
            dataField: 'bil',
            text: '#',
            headerClasses: "table-col-head",
            headerStyle: { width: "8%" }
        }, {
            dataField: 'staff_id',
            text: 'Staff No.',
            headerClasses: "table-col-head"
        }, {
            dataField: 'name',
            text: 'Name',
            headerClasses: "table-col-head",
            sort: true,
            headerStyle: { width: "40%" }
        },
        {
            dataField: 'email',
            text: 'Email',
            headerClasses: "table-col-head",
            sort: true
        },
        {
            dataField: 'contact',
            text: 'Contact',
            headerClasses: "table-col-head",
            sort: true
        }
    ];

    let data = []
    let bil = indexStart + 1;
    itemsList.forEach((id) => {
        let item = {}
        item['bil'] = bil++
        item['id'] = id
        item['staff_id'] = byid[id].staffId
        item['name'] = byid[id].name.toUpperCase()
        item['email'] = byid[id].email
        item['contact'] = byid[id].phoneNumber
        data.push(item)
    })

    const rowEvents = {
        onDoubleClick: (e, row) => {
            const user = byid[row.id]
            history.push({
                pathname: "/users/details",
                state: {
                    role: role,
                    user: user
                }
            });
        }
    };

    return (
        <BootstrapTable
            bootstrap4
            classes="table-md table-responsive-sm text-center align-middle"
            keyField='id'
            data={data}
            columns={columns}
            striped
            condensed
            hover
            bordered={false}
            noDataIndication="Record not found"
            rowEvents={rowEvents}
        />
    )
};

UserTable.propTypes = {
    users: PropTypes.object,
    role: PropTypes.string,
    history: PropTypes.object
};

export default UserTable;



// WEBPACK FOOTER //
// ./src/components/blocks/UserTable/UserTable.js